PJQ.views.budget.AddBudgetModificationsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-add-budget-modifications'),
        subTemplates: {
            modification: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'add-budget-modification')
        },
        maxWidth: 800,
        isShowCloseButton: true,
        onSave: _.noop
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-add-modification': 'addModification'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.budget = this.options.budget;

        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();

        this.collection = new PJQ.collections.budget.BudgetModifications();
        this.isFetched = true;
        this.render();
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.lineItemChoices = _.sortBy(_.map(this.budget.lineItems.models, (item) => {
            let costCode = this.costCodes.get(item.get('costCodeId')),
                costType = this.costTypes.get(item.get('costTypeId'));
            return {
                id: item.id,
                costCode: costCode,
                costType: costType,
                name: '<strong>' + costCode.getDisplayName() + '</strong> - ' + costType.get('name')
            };
        }), (choice) => {
            return choice.costCode.getDisplayName() + ' ' + choice.costType.get('name');
        });

        if (_.size(this.collection.models) === 0) {
            this.addModification();
        }
    },
    addModification: function () {
        let model = new PJQ.models.budget.BudgetModification({
            budgetId: this.budget.id,
            fromLineItemId: null,
            toLineItemId: null,
            amount: 0,
            notes: ''
        });

        this.collection.add(model);
        this.renderModification(model);
    },
    renderModification: function (model) {
        this.renderSubTemplate(true, this.options.subTemplates.modification, this.$('.budget-modifications'), {
            model: model,
            costCodes: this.costCodes,
            costTypes: this.costTypes,
            lineItems: this.budget.lineItems.models
        }, _.bind(function (el) {
            PJQ.helpers.inputHelpers.inputMaskCurrency(el.find('.input-dollars-full'), 2);
            new PJQ.Binder(el, model, {
                watchElements: [
                    'input'
                ]
            });

            model.fromSelect = new PJQ.inputs.Selectpicker({
                el: el.find('.line-item-from'),
                choices: this.lineItemChoices,
                noneSelectedText: 'Select Line Item',
                isLiveSearch: true,
                onChange: _.bind(function (value) {
                    model.set('fromLineItemId', value);
                }, this),
                defaultValue: null
            });

            model.toSelect = new PJQ.inputs.Selectpicker({
                el: el.find('.line-item-to'),
                choices: this.lineItemChoices,
                isLiveSearch: true,
                noneSelectedText: 'Select Line Item',
                onChange: _.bind(function (value) {
                    model.set('toLineItemId', value);
                }, this),
                defaultValue: null
            });
        }, this));
    },
    save: function () {
        let fnRender = _.bind(function () {
            if (typeof this.options.onSave === 'function') {
                this.options.onSave(this.collection.models);
            }
            this.removeModal();
        }, this)

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'budgets',
                    value: this.budget.id
                },
                {
                    endpoint: 'modifications'
                }
            ]),
            isAPIv2: true,
            data: this.collection.models
        }).post().done(_.bind(_.bind(function () {
            fnRender();
        }, this)));
    }
});

PJQ.views.budget.ViewBudgetModificationsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-view-budget-modifications'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        lineItem: null
    },
    events: {},
    beforeModalCreated: function () {
        this.collection = new PJQ.collections.budget.BudgetModifications(null, {
            budgetId: this.options.budget.id
        });
        this.collection.fetch({
            success: _.bind(function () {
                PJQ.app.session.project.fetchCostTypes(_.bind(function (costTypes) {
                    this.costTypes = costTypes;
                    PJQ.app.session.project.fetchCostCodes(_.bind(function (costCodes) {
                        this.costCodes = costCodes;
                        this.render();
                    }, this));
                }, this));
            }, this)
        });
    },
    renderData: function () {
        return {}
    },
    afterRender: function () {
        if (this.collection != null && this.collection.isFetched) {
            let fnLineItemRow = _.bind(function (data, type, row) {
                let lineItem = this.options.budget.lineItems.get(data);
                if (lineItem != null) {
                    let costCode = this.costCodes.get(lineItem.get('costCodeId'));
                    let costType = this.costTypes.get(lineItem.get('costTypeId'));

                    return costCode.get('name') + ' - ' + costType.get('code');
                }
                return 'N/A';
            }, this);

            let filteredData = this.options.lineItem != null ? _.filter(this.collection.models, function (model) {
                return model.get('fromLineItemId') === this.options.lineItem.id || model.get('toLineItemId') === this.options.lineItem.id
            }, this) : this.collection.models;
            new PJQ.views.dataTables.DataTable({
                el: this.$('.modifications-table'),
                data: filteredData,
                rowId: "id",
                paging: _.size(filteredData) > 10,
                order: [0, 'asc'],
                language: {
                    zeroRecords: 'This line item has no budget modifications'
                },
                columns: [
                    {
                        "data": "attributes.fromLineItemId",
                        "title": "From",
                        "minWidth": 200,
                        "render": fnLineItemRow
                    },
                    {
                        "data": "attributes.toLineItemId",
                        "title": "To",
                        "minWidth": 200,
                        "render": fnLineItemRow
                    },
                    {
                        "data": "attributes.amount",
                        "title": "Amount",
                        "width": 150,
                        "render": _.bind(function (data, type, row) {
                            let extraClasses = '';
                            if (this.options.lineItem != null) {
                                if ((row.get('fromLineItemId') === this.options.lineItem.id && row.get('amount') < 0)
                                    || (row.get('toLineItemId') === this.options.lineItem.id && row.get('amount') > 0)) {
                                    extraClasses = 'text-success';
                                } else {
                                    extraClasses = 'text-danger';
                                }
                            }
                            return '<span class="' + extraClasses + '">' + PJQ.helpers.formatHelpers.formatCurrency(data) + '</span>';
                        }, this)
                    },
                    {
                        "data": "attributes.notes",
                        "title": "Notes"
                    }
                ]
            })
        }
    }
});